import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  learnerInviteSuccessMsg: 'Invitation(s) sent successfully',
  learnerInvitePartialSuccessMsg: 'Some of the invitation(s) Sent Successfully',
  learnerInviteFailMsg: 'Invitation(s) not sent',
  inviteLearnersPageTitle: 'Invite learners',
  inviteLearnersPageSubtitle:
    'Invite learners to your workspace by adding their email addresses below',
  HeadingInviteLearnerInputField: 'Invite learners',
  SubmitButton: 'Submit',
  CancelButton: 'Cancel',
  learnerDeleteSuccessMsg: 'Learner deleted successfully',
  learnerActivated: 'Learner activated successfully',
  learnerRemoveFromCourseSuccess: 'Learner removed from the course',
  learnerReEnrollSuccess: 'Learner enrollment activated',
  EmailInstructions:
    'Use the Enter or Return key to add additional email addresses',
  learnerReEnrollFail: 'Failed to enroll learner in the course',
};

const welsh = {
  learnerInviteSuccessMsg: 'Anfonwyd gwahoddiad(au) yn llwyddiannus',
  learnerInvitePartialSuccessMsg:
    "Rhai o'r gwahoddiad(au) a anfonwyd yn llwyddiannus",
  learnerInviteFailMsg: 'Gwahoddiad(au) heb eu hanfon',
  inviteLearnersPageTitle: 'Gwahodd dysgwyr',
  inviteLearnersPageSubtitle:
    'Defnyddiwch y fysell Enter neu Return i ychwanegu cyfeiriadau e-bost ychwanegol',
  HeadingInviteLearnerInputField: 'Gwahodd dysgwyr',
  SubmitButton: 'Cyflwyno',
  CancelButton: 'Canslo',
  learnerDeleteSuccessMsg: "Dysgwr wedi'i dileu'n Llwyddiannus",
  learnerActivated: "Dysgwr wedi'i Ysgogi'n llwyddiannus",
  learnerRemoveFromCourseSuccess: "Dysgwr wedi'i dynnu o'r cwrs",
  learnerReEnrollSuccess: "Ymrestriad dysgwr wedi'i ysgogi",
  EmailInstructions:
    'Defnyddiwch yr allwedd dychwelyd neu nodi i ychwanegu cyfeiriadau e-bost ychwanegol',
  learnerReEnrollFail: 'Wedi methu â chofrestru dysgwr ar y cwrs',
};

export const learnersText: any = getLocalizationBasedOnLang(english, welsh);
